export default "__VITE_ASSET__DaI$JHLj__"